import React, { useState } from "react";
import { FiUser, FiEyeOff, FiLock, FiEye } from "react-icons/fi";
import { useNavigate, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../redux/auth/authActions";
import { addToastMsg } from "../redux/auth/authActions";
import { useEffect } from "react";
import app from "../axiosConfig";
import { validateEmail } from "../common/common";

function Login({
  user,
  setNotifications,
  setUnReadNotifications,
  setIsBadgeActive,
}) {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordDisplay, setPasswordDisplay] = useState(true);
  const [isResetPassword, setIsResetPassword] = useState(false);

  let handleSubmit = async (e) => {
    e.preventDefault();
    if (isResetPassword) {
      if (userId === "")
        return dispatch(
          addToastMsg("Please provide an email address", "error")
        );
      if (!validateEmail(userId))
        return dispatch(addToastMsg("Invalid email address", "error"));
      try {
        const { data } = await app.post("/auth/forgot-password", {
          userId,
        });
        setIsResetPassword(false);
        dispatch(addToastMsg(data?.message, "success"));

        return;
      } catch (error) {
        dispatch(addToastMsg(error?.response?.data?.message, "error"));
      }
    } else {
      if (userId === "" || password === "")
        return dispatch(addToastMsg("Please fill both the fields", "error"));

      if (!validateEmail(userId))
        return dispatch(addToastMsg("Invalid email address", "error"));
      dispatch(login({ userId, password }, navigate));
    }
  };

  useEffect(() => {
    setUnReadNotifications(0);
    setIsBadgeActive(false);
    setNotifications([]);
    // eslint-disable-next-line
  }, []);

  if (user) {
    return <Navigate to="/Home" replace />;
  }

  return (
    <div className="login-page-container">
      <img className="login-logo" src="/logo.svg" alt="" />
      {isResetPassword ? (
        <form className="login-form-container">
          <div className="reset-password-heading">
            <h2>Reset Password</h2>
            <p>
              Enter your email and we'll send you an email with the password
              reset link.
            </p>
          </div>
          <div className="login-input-container">
            <FiUser size={22} color="white" />
            <input
              className="login-input"
              label="User ID"
              autoComplete="username"
              placeholder="User ID"
              value={userId}
              type={"email"}
              onChange={(e) => setUserId(e.target.value)}
            />
          </div>
          <div className="login-btn-container">
            <button
              type="submit"
              className="login-btn"
              onClick={(e) => handleSubmit(e)}
            >
              Submit
            </button>
            <button
              type="submit"
              className="login-btn cancel-btn"
              onClick={() => setIsResetPassword(false)}
            >
              Cancel
            </button>
          </div>
        </form>
      ) : (
        <form
          className="login-form-container"
          onSubmit={(e) => handleSubmit(e)}
        >
          <div className="login-input-container">
            <FiUser size={22} color="white" />
            <input
              className="login-input"
              label="User ID"
              autoComplete="username"
              placeholder="User ID"
              type={"email"}
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </div>

          <div>
            <div className="login-input-container">
              <FiLock size={22} color="white" />
              <input
                className="login-input"
                label="Password"
                autoComplete="current-password"
                id="current-password"
                type={passwordDisplay ? "password" : "text"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {!passwordDisplay ? (
                <FiEyeOff
                  size={22}
                  color="white"
                  onClick={() => setPasswordDisplay(!passwordDisplay)}
                />
              ) : (
                <FiEye
                  size={22}
                  color="white"
                  onClick={() => setPasswordDisplay(!passwordDisplay)}
                />
              )}
            </div>

            <p
              className="forgot-password"
              onClick={() => setIsResetPassword(true)}
            >
              Forgot your password?
            </p>
          </div>
          <div className="login-btn-container">
            <button type="submit" className="login-btn">
              Login
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default Login;
